import qs from 'query-string';
import createDebug from 'debug';
import { UserFromCache, isUserFromCache } from './types';

const debug = createDebug('evp:onboarding:user');

const cacheKey = 'evpSignupUser';

export function saveUserToCache(user: UserFromCache): void {
  window.localStorage.setItem(cacheKey, JSON.stringify(user));
}

export function getUserFromLocalStorage(): UserFromCache | undefined {
  const data = window.localStorage.getItem(cacheKey);
  if (!data) return undefined;

  try {
    const json = JSON.parse(data);
    if (!isUserFromCache(json)) {
      debug('localStorage data does not conform to UserFromCache');
      return undefined;
    }
    return json;
  } catch (e) {
    debug('localStorage data contains invalid json');
    return undefined;
  }
}

export function getUserFromURL(): UserFromCache | undefined {
  const search = qs.parse(window.location.search);
  if (!search) return undefined;

  if (typeof search.email !== 'string') {
    debug('Missing email from URL');
    return undefined;
  }

  return {
    firstName: search.firstName || '',
    lastName: search.lastName || '',
    email: search.email,
    firstTime: typeof search.firstTime === 'boolean' ? search.firstTime : false,
    secret: search.secret || '',
  };
}

export function getUserFromCacheOrURL(): UserFromCache | undefined {
  const user = getUserFromURL();
  if (user) return user;

  return getUserFromLocalStorage();
}
